import authAxios from "../common/authAxios";
import { DictionaryCatalogDtoResponse } from "../interfaces/DictionaryCatalogDtoResponse";
import { InternshipDtoRequest, InternshipTypeDtoResponse } from "../interfaces/InternshipDto";

export class InternshipService {
    //Categories
    static async getCategories() {
        return authAxios.get<DictionaryCatalogDtoResponse[]>('/astanait-office-module/api/v1/internships/categories');
    }

    static async createCategory(data: DictionaryCatalogDtoResponse) {
        return authAxios.post('/astanait-office-module/api/v1/internships/categories', data);
    }

    static async updateCategory(id: number, data: DictionaryCatalogDtoResponse) {
        return authAxios.put(`/astanait-office-module/api/v1/internships/categories/${id}`, data);
    }

    static async deleteCategory(id: number) {
        return authAxios.delete(`/astanait-office-module/api/v1/internships/categories/${id}`);
    }

    //Types
    static async getTypes() {
        return authAxios.get<InternshipTypeDtoResponse[]>('/astanait-office-module/api/v1/internships/types');
    }

    static async createType(data: InternshipDtoRequest) {
        return authAxios.post('/astanait-office-module/api/v1/internships/types', data);
    }

    static async updateType(id: number, data: InternshipDtoRequest) {
        return authAxios.put(`/astanait-office-module/api/v1/internships/types/${id}`, data);
    }

    static async deleteType(id: number) {
        return authAxios.delete(`/astanait-office-module/api/v1/internships/types/${id}`);
    }
}